import React from "react";
import "./AboutUs.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFlask, faLeaf, faShieldHeart, faMedal } from "@fortawesome/free-solid-svg-icons";

const AboutUs = () => {
  return (
    <div id="about" className="about-us">
      <div className="about-container">
        {/* Hero Short Section */}
        <header className="about-header">
          <h1>About Us</h1>
          {/* <p>Where Science Meets Safe Home Care</p> */}
        </header>

        {/* Main Mission Section */}
        <section className="mission-block">
          <div className="mission-text">
            <h2>Our Mission</h2>
            <p>
              At New Life Research, we are committed to creating high-performance 
              housekeeping and hygiene products rooted in scientific research and 
              safe ingredients. Every formula is carefully developed to deliver 
              powerful results while being gentle for families, kids & pets.
            </p>
          </div>
          <div className="mission-image">
            <img src="https://i.pinimg.com/1200x/35/79/43/3579430cc73e0b5b1fed6cd7453095d7.jpg" alt="Lab Research Team" />
          </div>
        </section>

        {/* Story Section */}
        <section className="story-block">
          <div className="story-image">
            <img src="https://i.pinimg.com/736x/54/7d/f6/547df68c18d289d91f37b4550539c14e.jpg" alt="Healthy Clean Home" />
          </div>
          <div className="story-text">
            <h2>Our Story</h2>
            <p>
              Founded by professionals with expertise in home care science, 
              our journey started with a simple belief — hygiene shouldn’t be 
              harmful. Today, we bring nature-derived and advanced biotechnology 
              cleaning solutions to households across India.
            </p>
          </div>
        </section>

        {/* Values Section */}
        {/* <section className="values-grid">
          <div className="value-card">
            <FontAwesomeIcon icon={faFlask} className="value-icon" />
            <h3>Scientifically Developed</h3>
          </div>
          <div className="value-card">
            <FontAwesomeIcon icon={faLeaf} className="value-icon" />
            <h3>Plant-Derived Ingredients</h3>
          </div>
          <div className="value-card">
            <FontAwesomeIcon icon={faShieldHeart} className="value-icon" />
            <h3>Safe for Kids & Pets</h3>
          </div>
          <div className="value-card">
            <FontAwesomeIcon icon={faMedal} className="value-icon" />
            <h3>Premium Quality Standards</h3>
          </div>
        </section> */}
      </div>
    </div>
  );
};

export default AboutUs;
